import React from 'react';
import ErrorContainer from './containers';
import { useTranslation } from 'react-i18next';

const UnprocessableEntity = () => {
  const { t } = useTranslation();
  return <ErrorContainer message={t('errors.unprocessableEntity')} />;
};

export default UnprocessableEntity;
